/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Left-Arrow': {
    width: 28,
    height: 28,
    viewBox: '0 0 28 28',
    data: '<defs><path pid="0" id="svgicon_Left-Arrow_a" d="M7.06 8.94l-2.12 2.12L14 20.122l9.06-9.06-2.12-2.122L14 15.88z"/></defs><use _fill="#2d75f5" fill-rule="nonzero" transform="rotate(90 14 14.53)" xlink:href="#svgicon_Left-Arrow_a"/>'
  }
})
